import HTh from './HTh';

export default HTh;


// WEBPACK FOOTER //
// ./resources/assets/js/components/HTh/index.js